import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ProductsSource } from '@jane/monolith/sources/products';
/* eslint-disable-next-line no-restricted-imports */
import type { Product } from '@jane/shared/models';

export type ProductState = {
  isLoading: boolean;
  product: Product | undefined;
};

const getInitialState = (): ProductState => ({
  isLoading: true,
  product: undefined,
});

interface GetProductParams {
  id: string | number;
  storeId?: string | number;
}

export const getProduct = createAsyncThunk(
  'product/getProduct',
  async ({ id, storeId }: GetProductParams) => {
    const response = await ProductsSource.getProduct(id, storeId);
    return response.product;
  }
);

const productSlice = createSlice({
  name: 'product',
  initialState: getInitialState(),
  reducers: {
    resetProduct: () => {
      return getInitialState();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProduct.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProduct.fulfilled, (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
    });
    builder.addCase(getProduct.rejected, (state) => {
      state.isLoading = false;
    });
  },
  selectors: {
    selectProduct: (state) => state,
  },
});

export const {
  reducer: productReducer,
  actions: { resetProduct },
  selectors: { selectProduct },
} = productSlice;
